export default __webpack_public_path__ + "static/media/VolvoNovum-Medium.a3de727d.woff";